// src/user/services/api/fieldEngineers.js

import { apiRequest, buildUrl } from './index';

/**
 * Field Engineers API service
 * Handles all field engineer-related API calls
 */

/**
 * Create a new field engineer
 * @param {Object} data - Field engineer data
 * @param {string} data.access_key - The access key
 * @param {string} data.given_name - First name
 * @param {string} data.family_name - Last name
 * @param {string} data.company_name - Company name
 * @param {string} data.phone_number - Phone number
 * @param {string} data.email - Email address
 * @param {AbortSignal} [signal] - Optional abort signal
 * @returns {Promise<Object>} Created field engineer data
 */
export async function createFieldEngineer(data, { signal } = {}) {
  const url = buildUrl('/v1/field_engineers');
  return apiRequest(url, {
    method: 'POST',
    body: data,
    signal,
  });
}
